import { useAxiosQuery } from "../http/useAxiosQuery";
import { useHttp } from "../http/useHttp";
import { paths } from "../generated-types";

type UserReceiveConfigurationOperation =
  paths["/dashboard/users/{api_token_uuid}/receive-configuration"]["get"];
type UserReceiveConfigurationPath = UserReceiveConfigurationOperation["parameters"]["path"];
export type IUserReceiveConfigurationResponse =
  UserReceiveConfigurationOperation["responses"][200]["content"]["application/json"];
export type UseUserReceiveConfigurationInput = {
  id?: UserReceiveConfigurationPath["api_token_uuid"];
};

export const useUserReceiveConfiguration = (input?: UseUserReceiveConfigurationInput) => {
  const { client } = useHttp();
  const { status, isPending, isFetching, data, error, refetch } =
    useAxiosQuery<IUserReceiveConfigurationResponse>({
      queryKey: ["user-receive-configuration", input],
      queryFn: ({ signal }) => client.get(`/users/${input?.id}/receive-configuration`, { signal }),
      enabled: Boolean(input && input.id),
    });

  return {
    configuration: data ? data.data : null,
    status,
    isPending,
    isFetching,
    error,
    refetch,
  };
};

export type UseUserReceiveConfigurationReturn = ReturnType<typeof useUserReceiveConfiguration>;
